export enum TABS_STATE {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DISABLED = 'disabled'
}
